<style >
  .popup-global-position.k-simple-modal{
    top: 120px !important;
    transform: translate(-50%, 0%);
    height: -moz-fit-content;
    height: fit-content;
    overflow: auto;
    position: fixed;
  }
  #simple-modal.card-img-overlay{
    position: fixed !important;
  }
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position k-simple-modal">
    <div class="card mb-4">
      <div class="card-body p-5">
        <h4 class="mb-5" v-html="titolo"></h4>
        <p v-html="descrizione"></p>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery';
export default {
  name: "KSimpleModal",

  data(){
    return{
      titolo:'',
      descrizione:'',
      show:false
    }
  },
  created() {
    $(document).keyup(function(e) {
      if (e.key === "Escape"&&this.show) {
        this.annulla()
      }
    }.bind(this));
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showSimpleModal') {
        this.show=true;
        this.titolo=mutation.payload.titolo;
        this.descrizione=mutation.payload.descrizione;
        this.altriDettagli=mutation.payload.altriDettagli
      }
    });
  },
  methods:{
    annulla(){
      this.show=false;
      this.titolo='';
      this.descrizione='';
    }
  }
}
</script>